// Profile.tsx (Hardcoded Version)

import {
    Card,
    Grid,
    Box,
    Typography,
    Chip,
    useTheme,
    Avatar,
    CircularProgress,
} from '@mui/material';
import { styled } from '@mui/system';
import CakeIcon from '@mui/icons-material/Cake';
import ProfileImg from '../../Assets/profileImg.png';
import React, { useEffect, useState } from 'react';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import StudentProfileImage from '../../../Assets/student-profile.jpg';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ProgramImg from '../../Assets/programImg.png';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { makeStyles } from '@mui/styles';

import ModeEditIcon from '@mui/icons-material/ModeEdit';

import { Theme } from '@mui/material';
import MyStudentTabPanel from './MyStudentTabPanel';
import { studentsAcademicPlan, sudentsDataList } from '../../../Utils/apiService';

const useStyles = makeStyles((theme: Theme) => ({
    profileCard: {
        borderRadius: '6px !important',
        padding: '15px',
        boxShadow: 'none !important',
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            padding: '10px !important',
        },
    },
    postJobBtns: {
        width: '45%',
        height: '30px !important',
        borderRadius: '9px !important',
        marginTop: '10px !important',
        padding: '9px !important',
        fontSize: '12px !important',
        fontWeight: '500 !important',
        display: 'flex !important',
        justifyContent: 'center !important',
        alignItems: 'center !important',
        textAlign: 'center',
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            fontSize: '10px !important',
            padding: '5px !important',
            width: '45%',
            height: '26px !important',
        },
    },

    profileBox: {
        backgroundColor: '#EAEFFF !important',
        borderRadius: '6px !important',
        padding: '10px !important',
        marginTop: '20px !important',
    },
    verticalLine: {
        width: '1px',
        height: '100px',
        backgroundColor: '#E5E6EA',
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            height: '100px',
        },
    },
    profileName: {
        fontSize: '15px !important',
        textAlign: 'left',
        marginTop: '20px !important',
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            fontSize: '12px !important',
        },
    },
    profileBoxTitle: {
        fontSize: '16px !important',
        textAlign: 'left',
        fontWeight: '500 !important',
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            fontSize: '16px !important',
        },
    },
    profileBoxContent: {
        fontSize: '12px !important',
        textAlign: 'left',
        fontWeight: '400 !important',
        marginTop: '5px !important',
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            fontSize: '10px !important',
        },
    },
    table: {
        width: '100% !important',
    },
    th: {
        color: '#172E7D !important',
        fontSize: '12px !important',
        fontWeight: '500 !important',
        textAlign: 'left',
        padding: '10px !important',
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            fontSize: '11px !important',
        },
    },

    td: {
        fontSize: '12px !important',
        fontWeight: '400 !important',
        textAlign: 'left',
        padding: '10px !important',
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            fontSize: '11px !important',
        },
    },
    tableHeader: {
        position: 'sticky',
        top: 0,
        backgroundColor: '#F6F8FB !important',
        borderBottom: '0.5px solid #B2B3B7 !important',
        zIndex: 1, // ensure it's above the rest
    },
    tableHeaderA: {
        position: 'sticky',
        top: 0,
        backgroundColor: '#EAEFFF !important',
        borderBottom: '0.5px solid #B2B3B7 !important',
        zIndex: 1, // ensure it's above the rest
    },
    tableRow1: {
        backgroundColor: '#F6F8FB !important',
    },
    tableRowA: {
        backgroundColor: '#fff !important',
    },
    extraCuricularBox: {
        backgroundColor: '#F6F8FB !important',
        borderRadius: '12px !important',
        padding: '10px !important',
        height: '49.3vh !important',
        '@media (min-width: 1440px) and (max-width: 1500px)': {
            height: '52vh !important',
        },
        '@media (min-width: 1920px) and (max-width: 1940px)': {
            height: '54vh !important',
        },
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            padding: '10px !important',
            height: '43.8vh !important',
        },
    },
    extraCuricularBox2: {
        borderRadius: '12px !important',
        height: '49.3vh !important',
        '@media (min-width: 1440px) and (max-width: 1500px)': {
            height: '52vh !important',
        },
        '@media (min-width: 1920px) and (max-width: 1940px)': {
            height: '54vh !important',
        },
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            padding: '10px !important',
            height: '43.8vh !important',
        },
    },
    extraCuricularBox1: {
        backgroundColor: '#F6F8FB !important',
        borderRadius: '12px !important',
        padding: '15px !important',
        height: '49.3vh !important',
        '@media (min-width: 1440px) and (max-width: 1500px)': {
            height: '52vh !important',
        },
        '@media (min-width: 1920px) and (max-width: 1940px)': {
            height: '54vh !important',
        },
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            padding: '10px !important',
            height: '43.8vh !important',
        },
    },
    categoriesBox: {
        backgroundColor: '#FFFFFF !important',
        borderRadius: '12px !important',
        padding: '5px !important',
        marginTop: '10px !important',
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            marginTop: '5px !important',
            padding: '5px !important',
        },
    },
    categoriesBox1: {
        backgroundColor: '#FFFFFF !important',
        borderRadius: '12px !important',
        padding: '5px !important',
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            marginTop: '5px !important',
            padding: '5px !important',
        },
    },
    categoriesTitle: {
        fontSize: '15px !important',
        textAlign: 'left',
        fontWeight: '500 !important',
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            fontSize: '12px !important',
        },
    },
    categoriesBtns: {
        width: '100%',
        height: '36px !important',
        borderRadius: '8px !important',
        background: '#EAEFFF !important',
        borderShadow: 'none !important',
        color: "#5981FF !important",
        padding: '9px !important',
        fontSize: '12px !important',
        fontWeight: '500 !important',
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            fontSize: '10px !important',
            padding: '5px !important',
            height: '26px !important',
            width: '10%',
        },
    },
    categoryBtns: {
        width: '13%',
        height: '36px !important',
        borderRadius: '9px !important',
        padding: '9px !important',
        fontSize: '12px !important',
        fontWeight: '500 !important',
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            fontSize: '10px !important',
            padding: '5px !important',
            height: '26px !important',
            width: '10%',
        },
    },
    clubsBox: {
        backgroundColor: '#FFFFFF !important',
        borderRadius: '12px !important',
        padding: '16px !important',
        border: '0.5px solid #BFCEFF',
        marginTop: '10px !important',
    },
    clubsTitle: {
        fontSize: '14px !important',
        textAlign: 'left',
        fontWeight: '500 !important',
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            fontSize: '11px !important',
        },
    },
    clubsContent: {
        fontSize: '12px !important',
        textAlign: 'left',
        fontWeight: '400 !important',
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            fontSize: '10px !important',
        },
    },
    certificateBtns: {
        width: '100%',
        height: '36px !important',
        borderRadius: '9px !important',
        padding: '9px !important',
        fontSize: '12px !important',
        fontWeight: '500 !important',
        marginTop: '10px !important',
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            fontSize: '10px !important',
            padding: '5px !important',
            height: '26px !important',
        },
    },
    tableContainer: {
        border: '2px solid #E5E6EA',
        borderRadius: 10,
    },
    dilogHeader: {
        fontSize: '15px !important',
        fontWeight: '500 !important',
        marginBottom: '12px !important',
        borderBottom: '1px solid #BFCEFF',
        paddingBottom: '10px',
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            fontSize: '13px !important',
        },
    },
    dilogtypo: {
        fontSize: '12px !important',
        fontWeight: '500 !important',
        marginBottom: '8px !important',
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            fontSize: '11px !important',
        },
    },
    customSelect: {
        '& .MuiOutlinedInput-notchedOutline': {
            border: '0.5px solid #B2B3B7 !important',
            padding: '0px 12px !important',
            borderRadius: '6px !important',
        },
        '& .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.MuiSelect-select': {
            padding: '10px !important',
        },
        '& .MuiInputBase-input': {
            fontSize: '12px',
        },
        '& .MuiOutlinedInput-root': {
            height: '36px',
        },
    },
    customTextArea: {
        '& .MuiOutlinedInput-notchedOutline': {
            border: '0.5px solid #B2B3B7 !important',
            padding: '0px 12px !important',
            borderRadius: '6px !important',
        },
        '& .MuiInputBase-input': {
            fontSize: '12px',
        },
    },
    customText: {
        '& .MuiOutlinedInput-notchedOutline': {
            border: '0.5px solid #B2B3B7 !important',
            padding: '0px 12px !important',
            borderRadius: '6px !important',
        },
        '& .MuiInputBase-input': {
            fontSize: '12px',
        },
        '& .MuiOutlinedInput-root': {
            height: '36px',
        },
        '& .MuiInputBase-input.MuiOutlinedInput-input': {
            padding: '10px !important',
        },
    },
    profileButton: {
        borderRadius: '6px !important',
        boxShadow: 'none !important',
        height: '36px !important',
    },
    programsTitle: {
        fontSize: '14px !important',
        fontWeight: '500 !important',
        textAlign: 'left',
    },
    programsContent: {
        fontSize: '11px !important',
        fontWeight: '600 !important',
        textAlign: 'left',
    },
    programsScore: {
        color: '#2C58E8 !important',
        fontSize: '12px !important',
        fontWeight: '500 !important',
        textAlign: 'left',
    },
    programBox: {
        border: '1px solid #E9E9ED',
        borderRadius: '12px !important',
        padding: '12px !important',
    },
    AddButton: {
        background: 'linear-gradient(90deg, #3061FF -15.54%, #30C1FF 133.56%)',
        color: '#FFFFFF !important',
        borderRadius: '8px !important',
    }
}));



const MyStudentProfile = () => {
    const classes = useStyles();
    const theme = useTheme();
    const [studentDetails, setStudentDetails] = useState<any>();
    const [data, setData] = useState<any>([])
    const url = window.location.pathname;
    const segments = url.split('/');
    const studentId = segments[segments.length - 1];

    console.log(studentId, "dknvdjnoreud");


    const StudentCard = styled(Card)(({ theme }) => ({
        padding: theme.spacing(3),
        borderRadius: 16,
        backgroundColor: '#fff',
        boxShadow: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    }));

    const Label = styled(Typography)({
        fontSize: 12,
        color: '#8C8E94',
        lineHeight: '140%',
    });

    const Value = styled(Typography)({
        fontSize: 14,
        fontWeight: 500,
        color: '#373A45',
        lineHeight: '140%',
    });

    const StatusChip = styled(Chip)({
        // backgroundColor: '#C1DCC3',
        // color: '#1F4E21',
        fontWeight: 500,
        borderRadius: 20,
        padding: '0 12px',
        height: 30,
    });

    useEffect(() => {
        sudentsDataList(studentId).then((res) => {
            console.log(res, "skfjdfmdnsdjkfn");
            let response = res.data;
            let studentDetail = response.studentDetails[0];
            setStudentDetails(studentDetail);
            setData(response);

        }).catch((err) => {
            console.log(err, "skfjnsdjkfn");

        })
    }, [])

    function formatDateToShortString(dateString: string): string {
        try {
            if (typeof dateString !== "string") {
                throw new Error("Input must be a string");
            }

            const date = new Date(dateString);

            if (isNaN(date.getTime())) {
                throw new Error("Invalid date format");
            }

            const formatted = date.toLocaleDateString("en-US", {
                year: "numeric",
                month: "short",
                day: "numeric",
            });

            return formatted.replace(",", "");
        } catch (error: any) {
            console.error("Error formatting date:", error.message);
            return "Invalid Date"; // fallback value
        }
    }

    return (
        <div>
            <StudentCard>
                <Grid container spacing={3} alignItems="center">
                    {/* Left Section - Avatar and Name */}
                    <Grid item>
                        <Avatar
                            alt="WillJack"
                            src={StudentProfileImage}
                            sx={{ width: 132, height: 132, borderRadius: 2 }}
                        />
                    </Grid>

                    <Grid item xs textAlign={'left'}>
                        <div className='d-flex justify-content-between align-items-start'>
                            <div>
                                <Typography variant="h6" sx={{ fontWeight: 500, fontSize: 20 }}>
                                    {studentDetails?.Name}
                                </Typography>
                                <Typography sx={{ color: '#373A45', mb: 2 }}>
                                    {studentDetails?.Primary_Academic_Program__r?.Name || "N/A"}
                                </Typography>
                            </div>
                            {
                                studentDetails?.Status__c && <StatusChip label={studentDetails?.Status__c} />
                            }
                        </div>

                        {/* Info Section */}
                        <Grid container spacing={4}>
                            <Grid item>
                                <Box>
                                    <Label>Student ID</Label>
                                    <Value>{studentDetails?.Registration_Number__c || "N/A"}</Value>
                                </Box>
                            </Grid>
                            <Grid item>
                                <Box>
                                    <Label>Attendance</Label>
                                    <Value className="d-flex align-items-center">   <CircularProgress
                                        variant="determinate"
                                        value={data?.attendance}
                                        size={20}
                                        thickness={5}
                                        sx={{
                                            color: 72 < 50 ? '#C02B2B' : '#014F86',
                                            marginRight: 1
                                        }}
                                    /><Typography>{data?.attendance}%</Typography> </Value>
                                </Box>
                            </Grid>
                            <Grid item>
                                <Box>
                                    <Label>GPA</Label>
                                    <Value>{data?.gpa || "N/A"}</Value>
                                </Box>
                            </Grid>
                            <Grid item>
                                <Box>
                                    <Label>Counselor</Label>
                                    <Value>{studentDetails?.Counselor__r?.Name || "N/A"}</Value>
                                </Box>
                            </Grid>
                            <Grid item>
                                <Box>
                                    <Label>Homeroom advisor</Label>
                                    <Value>{studentDetails?.Homeroom_Advisor__r?.Name || "N/A"}</Value>
                                </Box>
                            </Grid>
                            <Grid item>
                                <Box >
                                    <Label>Birthday</Label>
                                    <Value className="d-flex align-items-center">
                                        <CakeIcon sx={{ fontSize: 16, verticalAlign: 'middle', mr: 0.5 }} />
                                        <div>{studentDetails?.Birthdate ? formatDateToShortString(studentDetails?.Birthdate) : "N/A"}</div>
                                    </Value>
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

            </StudentCard>

            <MyStudentTabPanel data={data} />

        </div>
    );
};

export default MyStudentProfile;
